import { ContentInterface, ListingItem } from "@/types/home.types";
import { Thumbnail } from "./common.types";
import { PaddingType } from "./designSystem.types";
import {
  MappedSelectedPeripheral,
  SelectedPeripheral,
} from "./contentDetails.types";
import { ContentTypeEnum, ShowFormatEnum } from "@/constants/constants";
import { SourcePagesEnum, SourceWidgetsEnum } from "@/constants/constants";

// Narrow keys to only those whose values are (optionally) strings on ContentInterface
export type StringKeysOf<T> = {
  [K in keyof T]-?: NonNullable<T[K]> extends string ? K : never;
}[keyof T];

export interface AllContentItem
  extends Omit<ListingItem, "slug" | "contentUrl"> {
  type: "show" | "episode";
  displaySlug: string;
  format?: ShowFormatEnum;
}

export interface AllContentRes {
  data: AllContentItem[];
}

export interface GenreDetailItem {
  contentType: ContentTypeEnum;
  _id: number;
  title: string;
  description: string;
  thumbnail: Thumbnail;
  selectedPeripheral?: SelectedPeripheral;
  slug: string;
}

export interface GenreDetailRes {
  genreWiseData: {
    genreId: number;
    genreName: string;
    movies: GenreDetailItem[];
    shows: GenreDetailItem[];
  }[];
}

export interface MappedGenreData {
  genreWiseData: {
    genreId: number;
    genreName: string;
    movies: ContentInterface[];
    shows: ContentInterface[];
  }[];
}

export interface ShowcaseGalleryData {
  title: string;
  description?: string;
  items: ContentInterface[];
  paddingVertical?: PaddingType;
  sourcePage: SourcePagesEnum;
  sourceWidget: string;
  autoFocusFirstItem?: boolean;
  showFilters?: boolean;
  pageFilters?: PageFiltersInterface;
}

export interface PageFiltersInterface {
  primaryFilter: {
    title?: string;
    matchKey?: StringKeysOf<ContentInterface>;
    options: {
      label: string;
      key: string;
    }[];
    selectedKeys?: string[];
  };
}

export interface PromotionClipData {
  descriptionText: string;
  infoText: string;
  playbackURL: string;
  thumbnailURL: string;
  titleText: string;
}

// mWeb Category Listing Types
export enum CategoryContentTypeEnum {
  MOVIES = "movies",
  SHOWS = "shows",
  MICRODRAMA = "microdrama",
}

export interface MicrodramaGenreItem {
  _id: number;
  title: string;
  description?: string;
  thumbnail: Thumbnail;
  selectedPeripheral?: SelectedPeripheral;
  slug: string;
  contentType: ContentTypeEnum;
}

export interface MicrodramaGenreSection {
  genreId?: number;
  genreName?: string;
  _id?: string;
  title?: string;
  microdramas: MicrodramaGenreItem[];
  movies: any[];
  shows: any[];
}

export interface MicrodramaGenreRes {
  genreWiseData: MicrodramaGenreSection[];
  top10Microdramas: {
    _id: string;
    title: string;
    data: MicrodramaGenreItem[];
  };
  trendingMicrodramas: {
    _id: string;
    title: string;
    data: MicrodramaGenreItem[];
  };
}

export interface MappedCategoryListingData {
  sections: {
    title: string;
    key: string;
    items: ContentInterface[];
    isTop10?: boolean;
    isTrending?: boolean;
  }[];
}

export interface ContentDeeplinkResponse {
  appsflyerUrl: string;
  contentId: number;
  contentType: string;
  dialect: string;
  language: string;
  slug: string;
}
